import Axios from "axios";
var PaymentService = (function () {
    function PaymentService() {
    }
    PaymentService.prototype.getCollectionRecords = function (params) {
        return Axios.get("supplierclientapi/paymentorder/get_receivable_list", { params: params });
    };
    PaymentService.prototype.getCollectionDetail = function (params) {
        return Axios.get("supplierclientapi/paymentorder/get_receivable_detail", { params: params });
    };
    PaymentService.prototype.getPaymentList = function (params) {
        return Axios.get("supplierclientapi/paymentorder/get_payment_order_list", { params: params });
    };
    PaymentService.prototype.getPaymentDetail = function (params) {
        return Axios.get("supplierclientapi/paymentorder/get_payment_order_detail", { params: params });
    };
    PaymentService.prototype.confirmBill = function (params) {
        return Axios.post("supplierclientapi/paymentorder/confirm_payment_order", params);
    };
    PaymentService.prototype.createBill = function (params) {
        return Axios.post("supplierclientapi/paymentorder/create", params);
    };
    PaymentService.prototype.saveBill = function (params) {
        return Axios.post("supplierclientapi/paymentorder/save", params);
    };
    PaymentService.prototype.discardBill = function (params) {
        return Axios.post("supplierclientapi/paymentorder/cancel", params);
    };
    PaymentService.prototype.changeIsTaxTicket = function (params) {
        return Axios.post("supplierclientapi/paymentorder/change_is_tax_ticket", params);
    };
    PaymentService.createInstance = function () {
        PaymentService.getInstance();
    };
    PaymentService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    PaymentService.prototype.getOrderDocumentList = function (params) {
        return Axios.get("supplierclientapi/paymentorder/order_document_list", { params: params });
    };
    return PaymentService;
}());
export default PaymentService;
